import { FC } from 'react';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { DataModalProps } from '@/types';
import { ModalSliceAdvertiserDisclosurePrimary } from '../../../../../prismicio-types';

import styles from './AdvertiserDisclosureModal.module.scss';

const titleComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.title}>{children}</p>,
};

const descriptionComponents: JSXMapSerializer = {
  paragraph: ({ children }) => <p className={styles.description}>{children}</p>,
};

export const AdvertiserDisclosureModal: FC<
  DataModalProps<ModalSliceAdvertiserDisclosurePrimary>
> = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      <ul className={styles.list}>
        {data.list.map((item, index) => (
          <li key={index} className={styles.item}>
            <PrismicRichText field={item.title} components={titleComponents} />
            <PrismicRichText
              field={item.description}
              components={descriptionComponents}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
